import { Component } from '@angular/core';
import { Layer } from '../../../../../../shared/models/layer';
import { LayerService } from '../../../../../../shared/services/layer.service';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-layers',
  templateUrl: './layers.component.html',
  styleUrls: ['./layers.component.scss']
})
export class LayersComponent {
  layer: Layer;
  faLayer = faLayerGroup;

  constructor(private layerService: LayerService) {
    // Obtenir l'état initial des couches
    this.layer = this.layerService.getLayerState();

    // Écouter les changements d'état des couches (y compris la désactivation)
    this.layerService.currentLayerState$.subscribe((newState) => {
      this.layer = newState;
    });
  }

  onLayerChange(): void {
    // Mettre à jour l'état des couches dans le service
    this.layerService.updateLayerState(this.layer);
  }
}
